export default __webpack_public_path__ + "static/media/profile.bb75914a.jpg";